import React from 'react'
import TestimonialShowcase from './templates/TestimonialShowcase'

const AuthFluidDisplay = (): JSX.Element => {
  // To change background image update the $auth-bg-pattern-img css variable
  return (
    <div className="auth-fluid-right text-center">
      <TestimonialShowcase
        title="Rotessa is celebrating 15 years of helping small businesses get paid."
        buttonLink="https://rotessa.com/who-we-are/"
        buttonText="Watch our story"
      />
    </div>
  )
}

export default AuthFluidDisplay
